import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal, Badge } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faPlus, faEdit, faTrash, faSave, faCheck, faLayerGroup } from '@fortawesome/free-solid-svg-icons';

/**
 * TurnTypeABM - Premium CRUD for Turn Categories
 */
const TurnTypeABM = ({ ipserv, hideHeader = false, branch_id }) => {
    const [loading, setLoading] = useState(false);
    const [types, setTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        TipoNombre: '',
        TipoAcronimo: '',
        TipoObservacion: '',
        TipoModalidad: 'PRESENCIAL',
        TipoVisibleTotem: 1
    });
    const [subStatus, setSubStatus] = useState(null);

    const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

    const loadTypes = () => {
        if (!branch_id) return;
        setLoading(true);
        request.Get(API_BASE + 'getTurneroTipos', { sucursalId: branch_id }, r => {
            if (r.success) {
                setTypes(r.rows || []);
            }
            setLoading(false);
        });
    };

    const loadSubscription = () => {
        request.Get(API_BASE + 'turnero/subscription-status', {}, r => {
            if (r.success) setSubStatus(r);
        });
    };

    useEffect(() => {
        loadTypes();
        loadSubscription();
    }, [branch_id]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setFormData(item || {
            TipoNombre: '',
            TipoAcronimo: '',
            TipoObservacion: '',
            TipoModalidad: 'PRESENCIAL',
            TipoVisibleTotem: 1
        });
        setShowModal(true);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(API_BASE + 'saveTurneroTipo', { ...formData, TipoId: currentItem?.TipoId, SucursalId: branch_id }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Tipo de Turno guardado correctamente' });
                setShowModal(false);
                loadTypes();
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al guardar' });
            }
            setLoading(false);
        });
    };

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Tipos de Turno</h2>
                    <p className="text-muted small">Gestiona las categorías de atención para esta sucursal.</p>
                </div>
                <button
                    className={`auth-btn-primary ${(!subStatus || subStatus.isExpired || types.length >= subStatus.plan.MaxTipos) ? 'opacity-50' : ''}`}
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
                    onClick={() => {
                        if (subStatus?.isExpired) {
                            Notify({ type: 'info', text: 'Tu plan ha vencido. Pásate a modo suscripción para seguir creando.' });
                        } else if (subStatus && types.length >= subStatus.plan.MaxTipos) {
                            Notify({ type: 'info', text: `Límite de tipos de turno alcanzado (${subStatus.plan.MaxTipos}) para tu plan ${subStatus.plan.PlanNombre}.` });
                        } else {
                            handleOpenModal();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nuevo Sector
                </button>
            </div>

            <div className="premium-table-container">
                <table className="premium-table">
                    <thead>
                        <tr>
                            <th>Nombre del Sector</th>
                            <th>Acrónimo</th>
                            <th>Descripción</th>
                            <th>Modalidad</th>
                            <th className="text-center">Tótem</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <AnimatePresence mode='popLayout'>
                            {loading && types.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center p-5">
                                        <Spinner animation="border" variant="primary" />
                                    </td>
                                </tr>
                            ) : types.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center p-5 text-muted">No hay tipos configurados para esta sucursal.</td>
                                </tr>
                            ) : (
                                types.map((t, idx) => (
                                    <motion.tr
                                        key={t.TipoId || idx}
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, scale: 0.95 }}
                                        transition={{ delay: idx * 0.05 }}
                                    >
                                        <td className="font-weight-bold" style={{ color: '#fff' }}>{t.TipoNombre}</td>
                                        <td>
                                            <span className="p-badge p-badge-primary">{t.TipoAcronimo}</span>
                                        </td>
                                        <td className="text-muted small">{t.TipoObservacion || 'Sin descripción'}</td>
                                        <td>
                                            <Badge bg={t.TipoModalidad === 'PRESENCIAL' ? 'info' : t.TipoModalidad === 'WEB' ? 'primary' : 'success'} className="tiny">
                                                {t.TipoModalidad}
                                            </Badge>
                                        </td>
                                        <td className="text-center">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className={t.TipoVisibleTotem ? "text-success" : "opacity-10"}
                                            />
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center gap-2">
                                                <button className="btn btn-link text-info p-0" onClick={() => handleOpenModal(t)}>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button className="btn btn-link text-danger p-0" onClick={() => {/* Delete logic */ }}>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </motion.tr>
                                ))
                            )}
                        </AnimatePresence>
                    </tbody>
                </table>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                className="premium-modal"
            >
                <form onSubmit={handleSave}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FontAwesomeIcon icon={faLayerGroup} className="mr-2 text-primary" />
                            {currentItem ? 'Editar Sector' : 'Nuevo Sector'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="auth-input-group">
                            <input
                                type="text"
                                className="auth-input"
                                value={formData.TipoNombre}
                                onChange={e => setFormData({ ...formData, TipoNombre: e.target.value.toUpperCase() })}
                                required
                                placeholder="Nombre (Ej: CAJAS, INFORMES)"
                            />
                            <FontAwesomeIcon icon={faLayerGroup} className="auth-input-icon" />
                        </div>

                        <div className="auth-input-group">
                            <input
                                type="text"
                                className="auth-input"
                                value={formData.TipoAcronimo}
                                onChange={e => setFormData({ ...formData, TipoAcronimo: e.target.value.toUpperCase() })}
                                required
                                maxLength="5"
                                placeholder="Acrónimo (Ej: CAJ, INF)"
                            />
                            <FontAwesomeIcon icon={faIdCard} className="auth-input-icon" />
                        </div>

                        <div className="auth-input-group">
                            <textarea
                                className="auth-input"
                                rows="2"
                                value={formData.TipoObservacion}
                                onChange={e => setFormData({ ...formData, TipoObservacion: e.target.value })}
                                placeholder="Descripción del sector..."
                                style={{ padding: '0.8rem 1rem' }}
                            />
                        </div>

                        <Row className="g-3 mb-3">
                            <Col md={12}>
                                <label className="tiny text-muted mb-2 font-weight-bold">MODALIDAD DE ATENCIÓN</label>
                                <select
                                    className="auth-input bg-dark-glass"
                                    value={formData.TipoModalidad}
                                    onChange={e => setFormData({ ...formData, TipoModalidad: e.target.value })}
                                    style={{ height: '50px' }}
                                >
                                    <option value="PRESENCIAL">SÓLO PRESENCIAL (TÓTEM)</option>
                                    <option value="WEB">SÓLO WEB (CITAS ONLINE)</option>
                                    <option value="AMBOS">AMBOS (HÍBRIDO)</option>
                                </select>
                            </Col>
                        </Row>

                        <div className="d-flex align-items-center mb-2 px-1">
                            <label className="checkbox-container-premium">
                                <input
                                    type="checkbox"
                                    checked={formData.TipoVisibleTotem === 1}
                                    onChange={e => setFormData({ ...formData, TipoVisibleTotem: e.target.checked ? 1 : 0 })}
                                />
                                <span className="checkmark"></span>
                                <span className="text-white ml-2 small font-weight-bold">MOSTRAR EN TÓTEM PRESENCIAL</span>
                            </label>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-link text-muted text-decoration-none" onClick={() => setShowModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="auth-btn-primary" style={{ width: 'auto', padding: '0.75rem 2rem' }} disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : (
                                <><FontAwesomeIcon icon={currentItem ? faSave : faCheck} /> {currentItem ? 'Actualizar' : 'Crear Sector'}</>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};

export default TurnTypeABM;
